import { Gender } from '@app/shared/enums/gender.enum';
import { PaymentType } from '@app/shared/enums/payment-type.enum';
import { ICountry, IVisitSlot } from '@app/shared/models';
import { IEmployee } from './employee.model';
import { ITreatmentApiModel } from './treatment-api.model';

export interface IBookVisitModel {
  customerId: string;
  salonId: string;
  customerFirstName: string;
  customerLastName: string;
  customerNameInfix: string;
  customerMobile: string;
  customerGender: Gender;
  customerEmail: string;
  customerPassword: string;
  customerCountry: ICountry;
  createCustomerAccount: boolean;
  remark: string;
  isNewCustomer?: boolean;
  treatmentAssignments: {
    employee: IEmployee;
    treatment: ITreatmentApiModel;
  }[];
  visitSlot: IVisitSlot;
  bookedWithWidget: boolean;
  paymentType: PaymentType;
  adviceRequested: boolean;
}
